export const ANALYTIC_ID = "UA-185659622-1";

// // --- Stage --- //
// export const STRIPE_ID = {
//   premium_monthly: "price_1LUoLvAlY9R4Wa1pW57ogfAf",
//   premium_quarterly: "price_1LUoLvAlY9R4Wa1pvUCJUKq8",
//   premium_yearly: "price_1LUoLvAlY9R4Wa1p63xnrDzq",
//   pro_monthly: "price_1LUoNVAlY9R4Wa1pasDLUkbq",
//   pro_quarterly: "price_1LUoNVAlY9R4Wa1prrRYzPlY",
//   pro_yearly: "price_1LUoNVAlY9R4Wa1poNKXsdh0",
//   lite_monthly: "price_1LUoKeAlY9R4Wa1pKWnFH3Pt",
//   lite_quarterly: "price_1LUoKeAlY9R4Wa1pjHhKUvSz",
//   lite_yearly: "price_1LUoKeAlY9R4Wa1pzJ3t9LGo",
// };
// export const STRIPE_PUBLIC =
//   "pk_test_51HWbXkAlY9R4Wa1pNNTATqAnlvpeeXyJ9I85E1B0QYUsIUPs84z84uQM9pVzm7hesVq2w6KQTmxu3tIXoEf0adRl0043MvXJnW";
// export const PAYPAL_CLIENT_ID =
//   "AQ58lfbo34MvYYhVOxBiLjziBQvAnOO5bN4JUdj9nxjiOKGkDn_03xqacAC8DWEj2vxCUh_8RSm6X_Pp";
// export const PAYPAL_ID = {
//   lite_monthly: "P-72J29231CS4680612ML7BARA",
//   lite_quarterly: "P-5M205282KR506954EML7BBEI",
//   lite_yearly: "P-4GF757066W302213UMMHP3GI",
//   premium_monthly: "P-76B0268383535172GMCXR7HQ",
//   premium_quarterly: "P-76B0268383535172GMCXR7HQ",
//   premium_yearly: "P-76B0268383535172GMCXR7HQ",
//   pro_monthly: "P-74U918610A5719342MCXR7TY",
//   pro_quarterly: "P-72J29231CS4680612ML7BARA",
//   pro_yearly: "P-52E196148S466304WMCXR74Y",
// };
// export const host = " https://api-stage.cfdhero.com/api";
// export const ws = "wss://api-stage.cfdhero.com";
// export const klineUrl = "https://api-stage.cfdhero.com/api/klines";



//--- Live --- //
export const STRIPE_ID = {
  premium_monthly: "price_1NkrpdAlY9R4Wa1pl4OXIlwi",
  premium_quarterly: "price_1NkrpdAlY9R4Wa1p5mSv4XPL",
  premium_yearly: "price_1NkrpdAlY9R4Wa1po1XJ76I9",
  pro_monthly: "price_1NkrrPAlY9R4Wa1pmsneLJl1",
  pro_quarterly: "price_1NkrrPAlY9R4Wa1pszPERRv6",
  pro_yearly: "price_1NkrrPAlY9R4Wa1p627RlxUa",
  lite_monthly: "price_1NkrllAlY9R4Wa1pmdGmotpS",
  lite_quarterly: "price_1NkrllAlY9R4Wa1p8TA8llwA",
  lite_yearly: "price_1NkrllAlY9R4Wa1pLbqu5zbt",
};

export const STRIPE_PUBLIC =
  "pk_live_51HWbXkAlY9R4Wa1pGcd1HUcYxePvFEvdo7kktBbLHVdzXzwdk6huL41PTb6KhV8ozYtEv4I95lWZ5yJ4U1u4AXDx00yKzkVoI2";
export const PAYPAL_CLIENT_ID =
  "Aej4A5zdJZPIlZYmDHFawL9TMZxQcLQ-3kqnNGdX-eZxiUZIrTYcClH9JDbXd5g5tf9ZhqpEaZWi9s_0";

export const PAYPAL_ID = {
  lite_monthly: "P-9Y928852G4827153JMSWQMPI",
  lite_quarterly: "P-4SP46469P6014921VMTW4MNY",
  lite_yearly: "P-97U644760W183301KMTW4NWY",
  premium_monthly: "P-1YM38384BM915790FMSWQNWA",
  premium_quarterly: "P-7JM7399514982654YMTW4PII",
  premium_yearly: "P-0XJ68753NL585063UMTW4QFQ",
  pro_monthly: "P-0FT41096AL771844TMSWQOFA",
  pro_quarterly: "P-8DF54929VH2325823MTW4RBQ",
  pro_yearly: "P-28T685298J670293CMTW4SKY",
};
export const host = "https://api.cfdhero.com/api";

export const ws = "wss://api.cfdhero.com";
export const klineUrl = "https://api.cfdhero.com/api/klines";
